import { render, staticRenderFns } from "./RegisterPassword.vue?vue&type=template&id=0338eb84&scoped=true"
import script from "./RegisterPassword.vue?vue&type=script&setup=true&lang=js"
export * from "./RegisterPassword.vue?vue&type=script&setup=true&lang=js"
import style0 from "./RegisterPassword.vue?vue&type=style&index=0&id=0338eb84&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0338eb84",
  null
  
)

export default component.exports